import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { stages } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function CaseStructure() {
  return <section className="bg-cream px-4 py-16" aria-labelledby="cs-title" data-id="element-68" data-mp="1fr9ukkwjxx7e">
      <div className="mx-auto max-w-3xl" data-id="element-69" data-mp="1ftcr7ns7mol3">
        <h2 id="cs-title" className="text-center font-serif text-[2rem] font-bold leading-tight text-ink sm:text-5xl" data-id="element-70" data-mp="1kqupmk8lpleu">
          The 15-Minute <span className="italic text-gold-dark" data-id="element-71" data-mp="n45gzrje8ak0">Case Structure™</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-lg leading-relaxed text-muted" data-id="element-72" data-mp="s2qhzt6gyy9i">
          Instead of opening multiple courses, searching through notes, or starting from a blank page… you follow one
          structured framework.
        </p>

        <ol className="mt-10" data-id="element-73" data-mp="28fxgmip4kqm0">
          {stages.map((stage, i) => <li key={stage.name} data-id="element-74" data-mp="28fnsl0nn4tiy" data-mpi={i}>
              <div className="flex items-center gap-4 rounded-2xl bg-ink p-5 text-white sm:p-6" data-id="element-75" data-mp="2ch8yg21rc7jn">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-gold font-serif text-2xl font-bold text-ink" data-id="element-76" data-mp="3q12hkeurvk5e">
                  {i + 1}
                </span>
                <div data-id="element-77" data-mp="3g34sjp539jbq">
                  <h3 className="font-serif text-2xl font-bold uppercase tracking-wide text-gold-light" data-id="element-78" data-mp="3g2d9tewlbg2v">{stage.name}</h3>
                  <p className="mt-1 text-base leading-snug text-white/75" data-id="element-79" data-mp="3c0rnl2y61pg0">{stage.text}</p>
                </div>
              </div>
              {i < stages.length - 1 && <div className="flex justify-center py-2" aria-hidden="true" data-id="element-80" data-mp="32b88m8dkqfqf">
                  <ArrowDownIcon className="h-6 w-6 text-gold-dark" data-id="element-81" data-mp="2xcn6g3erhlzc" />
                </div>}
            </li>)}
        </ol>

        <p className="mt-8 text-center font-serif text-xl font-bold text-ink" data-id="element-82" data-mp="2seva8x733dpc">
          One framework. Five stages. One organized system.
        </p>

        <SectionCTA label="I want the 15-minute case structure" data-id="element-83" data-mp="2jd48g3fnzr0r" />
      </div>
    </section>;
}